export default "__VITE_ASSET__CLLewEO2__"